module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-ES.bcbc8d84.png";